import { render, staticRenderFns } from "./people-table.vue?vue&type=template&id=1525acbd&"
import script from "./people-table.vue?vue&type=script&lang=js&"
export * from "./people-table.vue?vue&type=script&lang=js&"
import style0 from "./people-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports